import { render, staticRenderFns } from "./RemoveFromCart.vue?vue&type=template&id=2f78f8ad"
import script from "./RemoveFromCart.vue?vue&type=script&lang=js"
export * from "./RemoveFromCart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports